export const locale = {
  lang: "en",
  data: {
    MENU: {
      HOME: "Home",
      SAMPLE: "Sample",
      ADMIN: "Administrator",
      USERS: "Users",
      RESTAURANTS: "Companies",
    },
    AUTH: {
      WELCOME: "Welcome to the Kinderfreunde Dokutool! 🗒️",
      INTRO: "Please sign-in to your account!",
      EMAIL: "Email",
      PASSWORD: {
        PASSWORD: "Password",
        FORGOT: "Forgot Password?",
        RESET: "Enter your email and we'll send you instructions to reset your password",
        RESET_LINK: "Send reset link",
        RESET_HEADER: "Reset Password 🔒",
        NEW: "New Password",
        CONFIRM: "Confirm new password",
      },
      ERRORS: {
        EMAIL_REQUIRED: "Email is required",
        EMAIL: "Email must be a valid email address",
        PASSWORD: "Password is required",
        PASSWORD_CHECK: "Passwords do not match",
      },
      REMEMBER_ME: "Remember me",
      SIGN_IN: "Sign in",
      NEW: "New on our platform? ",
      REGISTER: "Create an account",
      OR: "or",
      LOGIN_SUCCESS_MESSAGE: "You have successfully logged in as a {{role}} user to Kinderfreunde Dokutool. 🎉",
      LOGIN_SUCCESS_TITLE: "👋 Welcome, {{name}}!",
      BACK_TO_LOGIN: "Back to login",
      REGISTER_TITLE: "Adventure starts here 🚀",
      USERNAME: "Username",
      TCS: "I agree to the privacy policy & terms",
      ALREADY_REGISTERED: "Already have an account?",
    },
    NAV: {
      PROFILE: "Profile",
      INBOX: "Inbox",
      TASK: "Task",
      CHATS: "Chats",
      LOGOUT: "Logout",
      REPRESENT: "Login as",
    },
  },
};
